<template>
  <div style="padding: 30px">
    <div class="d-flex justify-space-between align-center mb-4">
      <h2 class="text-h5">Shipping Templates</h2>
      <v-btn color="primary" @click="fetchFromApi" :loading="fetching" class="text-capitalize">
        <v-icon left>{{ icons.mdiDownload }}</v-icon>
        Fetch from Etsy API
      </v-btn>
    </div>

    <v-data-table :headers="headers" :items="shipping_templates" :items-per-page="10" class="elevation-1 mt-5">
      <template v-slot:top>
        <v-row style="padding: 10px">
          <v-col md="2" cols="6">
            <strong>Total: </strong> {{ shipping_templates.length }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:body="{ items }">
        <tbody v-if="!is_loading">
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.shipping_template_id }}</td>
            <td>{{ item.title }}
              <v-chip small class="ma-2" color="primary" v-if="item.is_calculated == '1'" text-color="white">Calculated</v-chip>
            </td>
            <td>{{ item.country }}</td>
            <!-- <td>{{ item.processing_days_display_label }}</td> -->
            <!-- <td>
              <v-chip small class="ma-2" color="green" text-color="white" v-if="item.app_status == '1'">Active</v-chip>
              <v-chip small class="ma-2" color="red" text-color="white" v-else>Inactive</v-chip>
            </td>
            <td>
              {{ item.last_feed_refresh | date_format('timeago') }}
            </td>
            <td>
              <router-link :to="{ name: 'shops-detail', params: { shop_id: item.id } }">
                <v-btn fab small color="primary darken-1" class="table-action--button">
                  <v-icon small dark>{{ mdiMagnify }}</v-icon>
                </v-btn>
              </router-link>
            </td> -->
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center" style="padding: 80px 0px">
              <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import store from '@/store'
import { mdiDownload } from '@mdi/js'

export default {
  data() {
    return {
      shop: null,
      is_loading: false,
      fetching: false,
      shipping_templates: [],
      headers: [
        { text: 'ID', value: 'shipping_template_id' },
        { text: 'Title', value: 'title' },
        { text: 'Country', value: 'country' },
      ],
      icons: {
        mdiDownload: mdiDownload,
      },
    }
  },
  mounted() {
    this.shop = store.getters.loggedInShop
    this.fetshShippingTemplates()
  },
  methods: {
    async fetshShippingTemplates() {
      try {
        this.is_loading = true
        let response = await axios.get(`admin/shops/${this.shop.id}/get-shipping-templates`)
        if (response.data.success) {
          this.shipping_templates = response.data.shipping_templates || []
        }
      } catch (e) {
        console.error('Error fetching shipping templates:', e)
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch shipping templates',
        })
      } finally {
        this.is_loading = false
      }
    },
    async fetchFromApi() {
      try {
        this.fetching = true
        let response = await axios.get(`/admin/shops/${this.shop.id}/shipping-templates/fetch`)
        if (response.data.success) {
          this.$swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.data.message || 'Shipping templates fetched successfully',
          })
          await this.fetshShippingTemplates()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: response.data.message || 'Failed to fetch shipping templates',
          })
        }
      } catch (e) {
        console.error('Error fetching from API:', e)
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch shipping templates from Etsy API',
        })
      } finally {
        this.fetching = false
      }
    },
  },
}
</script>
